import { Injectable } from '@angular/core';
import { EncriptDecriptService } from '../../../services/encriptdecript';

@Injectable()
export class AuthService {

    private userDetail: any;
    // store the URL so we can redirect after logging in
    redirectUrl: string;
    public userObject:any;
    constructor(private encriptDcript:EncriptDecriptService) { 
        this.userObject = this.encriptDcript.getLocalStorage('userObject');
        if(this.userObject!=undefined&&this.userObject!=null){
            this.userDetail = JSON.parse(this.userObject);
        }else{
            this.isAunthenticated();
        }
     }

    public isAunthenticated(): boolean {
        this.userDetail ? this.userDetail : this.userDetail = undefined;
        if (this.userDetail) {
            return this.userDetail.isAdmin ?  true : this.checkPermision(this.userDetail);
        } else {
            return false;
        }
    }

    private checkPermision(userDetail): boolean {
        let canAccess = false;
        const role = userDetail.roles[0];

        for (let i = 0; i < role.applicationRolePermission.length; i++) {
            if (role.applicationRolePermission[i].isUpdate ||
                role.applicationRolePermission[i].isWrite ||
                role.applicationRolePermission[i].isDelete) {
                return   canAccess = true;
            } else {  canAccess = false; }
        }
        return canAccess;
    }

    public authComponent(url) {
        if (this.userDetail.isAdmin) {
            return true;
        } else {
            return this.checkComponentPermission(url);
        }
    }

    private checkComponentPermission(url) {
        const role = this.userDetail.roles[0];

        for (const permission of role.applicationRolePermission) {
            const urlCode: string = url.toLowerCase();
            const componentCode: string = permission.component.code.toLowerCase();
            if (urlCode.includes(componentCode)) {
                if (this.isAnyPermision(permission)) {
                    return true;
                }
            }
        }
        return false;
    }

    private isAnyPermision(component) {
        return (component.isWrite || component.isUpdate || component.isDelete || component.isRead);
    }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin-services/auth.service.ts